import { useEffect, useState } from 'react';

function Home() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch("/api/hello")
      .then((res) => res.json())
      .then((data) => setMessage(data.message));
  }, []);

//   return <div className="page-container">
//     <div className="body-text">{message || "Loading..."}</div>
//     </div>;

    return (
    <div className="page-container">
    {/* Uncomment the SVG below to add a background blob effect */}
    {/* <svg className="page-blob-bg" viewBox="0 0 200 200" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFD6E8" d="M49.6,-56.5C64.6,-46.5,77.4,-31.2,81.6,-13.4C85.9,4.3,81.7,24.5,69.7,35.5C57.7,46.5,38,48.3,21,52C4.1,55.6,-10.1,61.2,-26.7,60.7C-43.2,60.1,-62.1,53.4,-73.4,39.6C-84.8,25.7,-88.6,4.7,-82.1,-11.3C-75.5,-27.4,-58.5,-38.5,-43.1,-48.4C-27.7,-58.4,-13.9,-67.2,1.7,-69.3C17.3,-71.3,34.6,-66.5,49.6,-56.5Z" transform="translate(100 100)" />
    </svg> */}
    <div className="text-container">
        <h1 className="page-title">welcome to my site!</h1>
        <div className="body-text">{message || "Loading..."}</div>
    </div>
    </div>
  );
}

export default Home;